import { NextImage } from '@apeiron/temp'
import { Box, styled, Typography } from '@mui/material'
import * as R from 'ramda'
import { FC } from 'react'

const Container = styled(Box)`
  align-items: center;
  display: flex;
  gap: 5px;
`

const Icon = styled(NextImage)`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`

const Exponential = styled(Typography)`
  white-space: nowrap;
`

const StyledNumberFormat = styled(Typography)`
  white-space: nowrap;
`

const PriceText: FC<Props> = (props: Props) => {
  const { className, disabled = false, icon, prefix = '', displayPrice } = props

  if (disabled) {
    return <Box className={className}>N/A</Box>
  }

  const isExpNumber = displayPrice.includes('e')

  return (
    <Container className={className}>
      {!R.isNil(icon) ? <Icon className='Custom-Icon' src={icon} /> : <></>}
      {isExpNumber ? (
        <Exponential className='Custom-Text'>{`${prefix}${displayPrice}`}</Exponential>
      ) : (
        <StyledNumberFormat className='Custom-Text'>
          {prefix}
          {displayPrice}
        </StyledNumberFormat>
      )}
    </Container>
  )
}

type Props = {
  className?: string
  disabled?: boolean
  icon?: string
  prefix?: string
  displayPrice: string
}

export default PriceText
